
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-popup-open]');
  if (!trigger) return;

  e.preventDefault();

  const popupId = trigger.dataset.popupOpen;
  const popup = document.getElementById(popupId);
  const overlay = document.getElementById(popupId + '-overlay');

  if (!popup) {
    console.warn('Popup introuvable :', popupId);
    return;
  }

  popup.classList.add('active');
  if (overlay) overlay.classList.add('active');
  document.body.classList.add('custom-popup-open');
});

document.addEventListener('click', function (e) {
  if (
    e.target.classList.contains('custom-popup-close') ||
    e.target.classList.contains('custom-popup-overlay')
  ) {
    document.querySelectorAll('.custom-popup-box.active').forEach(p => p.classList.remove('active'));
    document.querySelectorAll('.custom-popup-overlay.active').forEach(o => o.classList.remove('active'));
    document.body.classList.remove('custom-popup-open');
  }
});
